import { useRef } from "react";

import { cn, Table } from "twyne-new.ui";

import { useAutoResize, useColumnSizeVariables } from "@/components/tableResize/hooks";

import NoContent from "./NoContent";
import { useTableContext } from "./context";

export default function TableResizeWrapper({ columns, data, noDataIndication, children, className = '' }) {
  const tableRef = useRef(null)
  useAutoResize({ tableRef, tableContext: useTableContext, columns })
  const { isFixedLayout } = useTableContext()
  const columnSizeVariables = useColumnSizeVariables({ tableRef, tableContext: useTableContext })

  return <div ref={tableRef} className='relative'>
    <Table containerClassName={className}
      className={cn('w-full', isFixedLayout ? 'table-fixed' : 'table-auto')}
      style={columnSizeVariables}
    >
      {children}
    </Table>
    <NoContent data={data} noDataIndication={noDataIndication} />
  </div>
}
